/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earth_Day_2025_Partner_Sponsor_PageInputs */

const en_earth_day_2025_partner_sponsor_page = /** @type {(inputs: Earth_Day_2025_Partner_Sponsor_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`official site`)
};

const ar_earth_day_2025_partner_sponsor_page = /** @type {(inputs: Earth_Day_2025_Partner_Sponsor_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الموقع الرسمي`)
};

const de_earth_day_2025_partner_sponsor_page = /** @type {(inputs: Earth_Day_2025_Partner_Sponsor_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`offizielle Seite`)
};

const es_earth_day_2025_partner_sponsor_page = /** @type {(inputs: Earth_Day_2025_Partner_Sponsor_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sitio oficial`)
};

const fr_earth_day_2025_partner_sponsor_page = /** @type {(inputs: Earth_Day_2025_Partner_Sponsor_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`site officiel`)
};

const it_earth_day_2025_partner_sponsor_page = /** @type {(inputs: Earth_Day_2025_Partner_Sponsor_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sito ufficiale`)
};

const ja_earth_day_2025_partner_sponsor_page = /** @type {(inputs: Earth_Day_2025_Partner_Sponsor_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公式サイト`)
};

const ko_earth_day_2025_partner_sponsor_page = /** @type {(inputs: Earth_Day_2025_Partner_Sponsor_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`공식 홈페이지`)
};

const pt_br_earth_day_2025_partner_sponsor_page = /** @type {(inputs: Earth_Day_2025_Partner_Sponsor_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`site oficial`)
};

const ru_earth_day_2025_partner_sponsor_page = /** @type {(inputs: Earth_Day_2025_Partner_Sponsor_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`официальный сайт`)
};

const th_earth_day_2025_partner_sponsor_page = /** @type {(inputs: Earth_Day_2025_Partner_Sponsor_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เว็บไซต์อย่างเป็นทางการ`)
};

const tr_earth_day_2025_partner_sponsor_page = /** @type {(inputs: Earth_Day_2025_Partner_Sponsor_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`resmi internet sitesi`)
};

const zh_cn_earth_day_2025_partner_sponsor_page = /** @type {(inputs: Earth_Day_2025_Partner_Sponsor_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`官方网站`)
};

const zh_tw_earth_day_2025_partner_sponsor_page = /** @type {(inputs: Earth_Day_2025_Partner_Sponsor_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`官方網站`)
};

/**
* | output |
* | --- |
* | "official site" |
*
* @param {Earth_Day_2025_Partner_Sponsor_PageInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const earth_day_2025_partner_sponsor_page = /** @type {((inputs?: Earth_Day_2025_Partner_Sponsor_PageInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earth_Day_2025_Partner_Sponsor_PageInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earth_day_2025_partner_sponsor_page(inputs)
	if (locale === "ar") return ar_earth_day_2025_partner_sponsor_page(inputs)
	if (locale === "de") return de_earth_day_2025_partner_sponsor_page(inputs)
	if (locale === "es") return es_earth_day_2025_partner_sponsor_page(inputs)
	if (locale === "fr") return fr_earth_day_2025_partner_sponsor_page(inputs)
	if (locale === "it") return it_earth_day_2025_partner_sponsor_page(inputs)
	if (locale === "ja") return ja_earth_day_2025_partner_sponsor_page(inputs)
	if (locale === "ko") return ko_earth_day_2025_partner_sponsor_page(inputs)
	if (locale === "pt_br") return pt_br_earth_day_2025_partner_sponsor_page(inputs)
	if (locale === "ru") return ru_earth_day_2025_partner_sponsor_page(inputs)
	if (locale === "th") return th_earth_day_2025_partner_sponsor_page(inputs)
	if (locale === "tr") return tr_earth_day_2025_partner_sponsor_page(inputs)
	if (locale === "zh_cn") return zh_cn_earth_day_2025_partner_sponsor_page(inputs)
	return zh_tw_earth_day_2025_partner_sponsor_page(inputs)
});